import {
    ACCEPTANCE_CERT_DATE,
    CAR_BODY_NUMBER,
    CAR_COLOR,
    CAR_ENGINE_MODEL,
    CAR_ENGINE_NUMBER,
    CAR_ENGINE_OIL,
    CAR_ENGINE_POWER,
    CAR_ENGINE_VOLUME,
    CAR_FRAME_NUMBER,
    CAR_MILEAGE,
    CAR_MODEL,
    CAR_NUMBER,
    CAR_PRICE,
    CAR_TYPE,
    CAR_VIN,
    CAR_YEAR,
    CREATION_DATE,
    CREATION_PLACE,
    CUSTOMER_FIO,
    CUSTOMER_PASSPORT_ADDRESS,
    CUSTOMER_PASSPORT_BIRTHDAY,
    CUSTOMER_PASSPORT_CODE,
    CUSTOMER_PASSPORT_DATE,
    CUSTOMER_PASSPORT_ISSUER,
    CUSTOMER_PASSPORT_NUMBER,
    CUSTOMER_PASSPORT_SERIES,
    DAMAGE_DESCRIPTION,
    FIO,
    PASSPORT_ADDRESS,
    PASSPORT_BIRTHDAY,
    PASSPORT_CODE,
    PASSPORT_DATE,
    PASSPORT_ISSUER,
    PASSPORT_NUMBER,
    PASSPORT_SERIES,
    PTC_DATE,
    PTC_ISSUER,
    PTC_SERIES,
    PTS_NUMBER,
    STS_DATE,
    STS_ISSUER,
    STS_NUMBER,
    STS_SERIES
} from "./contract-generator.constants";
import { minLengthValidation } from "./lib/minLengthValidation";

const DATE_VALIDATION = {
    pattern: {
        value: /^(0[1-9]|[12][0-9]|3[01])\.(0[1-9]|1[0-2])\.(19|20)\d{2}$|^(0[1-9]|1[0-9]|2[0-9])\.02\.(19|20)\d{2}$/,
        message: "Введите дату в формате ДД.ММ.ГГГГ."
    }
};

const NUMBERS_CARS_VALIDATION = {
    pattern: {
        value: /^(-|.{4,})$/,
        message: "Введите корректный номер (минимум 4 символа) или '-' если он отсутствует."
    }
};

export const Validations = {
    [CREATION_DATE]: DATE_VALIDATION,
    [CREATION_PLACE]: minLengthValidation(5, "Введите корректную место составления"),
    [FIO]: {
        pattern: {
            value: /^[А-Яа-яЁё -]+$/,
            message: "ФИО может содержать только буквы русского алфавита, пробелы и дефисы."
        },
        ...minLengthValidation(5, "Введите ФИО длиной не менее 5 символов.")
    },
    [PASSPORT_NUMBER]: {
        pattern: {
            value: /^\d{6}$/,
            message: "Номер паспорта должен содержать ровно 6 цифр."
        }
    },
    [PASSPORT_DATE]: DATE_VALIDATION,
    [PASSPORT_CODE]: {
        pattern: {
            value: /^\d{3}-\d{3}$/,
            message: "Код подразделения должен состоять из 6 цифр в формате: 123-456."
        }
    },
    [PASSPORT_ISSUER]: {
        pattern: {
            value: /^[А-Яа-яЁё0-9 -]+$/,
            message:
                "Введите корректное значение: только кириллические буквы, цифры, пробелы и дефисы."
        },
        ...minLengthValidation(5, "Значение должно содержать не менее 5 символов.")
    },
    [PASSPORT_BIRTHDAY]: {
        pattern: {
            value: /^(0[1-9]|[12][0-9]|3[01])\.(0[1-9]|1[0-2])\.(19|20)\d{2}$|^(0[1-9]|1[0-9]|2[0-9])\.02\.(19|20)\d{2}$/,
            message: "Введите дату в формате ДД.ММ.ГГГГ."
        }
    },
    [PASSPORT_ADDRESS]: {
        pattern: {
            value: /^[А-Яа-яЁё0-9 -]+$/,
            message:
                "Введите корректное значение: только буквы русского алфавита, цифры, пробелы и дефисы."
        },
        ...minLengthValidation(5, "Значение должно содержать не менее 5 символов.")
    },
    [CUSTOMER_FIO]: {
        pattern: {
            value: /^[А-Яа-яЁё -]+$/,
            message: "ФИО может содержать только буквы русского алфавита, пробелы и дефисы."
        },
        ...minLengthValidation(5, "Введите ФИО длиной не менее 5 символов.")
    },
    [CUSTOMER_PASSPORT_NUMBER]: {
        pattern: {
            value: /^\d{6}$/,
            message: "Номер паспорта должен содержать ровно 6 цифр."
        }
    },
    [CUSTOMER_PASSPORT_DATE]: DATE_VALIDATION,
    [CUSTOMER_PASSPORT_CODE]: {
        pattern: {
            value: /^\d{3}-\d{3}$/,
            message: "Код подразделения должен состоять из 6 цифр в формате: 123-456."
        }
    },
    [CUSTOMER_PASSPORT_ISSUER]: {
        pattern: {
            value: /^[А-Яа-яЁё0-9 -]+$/,
            message:
                "Введите корректное значение: только буквы русского алфавита, цифры, пробелы и дефисы."
        },
        ...minLengthValidation(5, "Значение должно содержать не менее 5 символов.")
    },
    [CUSTOMER_PASSPORT_BIRTHDAY]: DATE_VALIDATION,
    [CUSTOMER_PASSPORT_ADDRESS]: {
        pattern: {
            value: /^[А-Яа-яЁё0-9 -]+$/,
            message:
                "Введите корректное значение: только буквы русского алфавита, цифры, пробелы и дефисы."
        },
        ...minLengthValidation(5, "Значение должно содержать не менее 5 символов.")
    },
    [CAR_MODEL]: minLengthValidation(5, "Введите корректное значение"),
    [CAR_VIN]: {
        pattern: {
            value: /^[A-HJ-NPR-Z0-9]{17}$/,
            message: "VIN должен содержать 17 символов: только заглавные латинские буквы и цифры."
        }
    },
    [CAR_TYPE]: minLengthValidation(5, "Введите корректное значение"),
    [CAR_YEAR]: {
        validate: (val: string) => {
            if (!val) {
                return true;
            }
            if (val.length < 4) {
                return "Введите корректный год";
            }
            return true;
        }
    },
    [CAR_MILEAGE]: minLengthValidation(4, "Введите корректный пробег"),
    [CAR_ENGINE_POWER]: minLengthValidation(3, "Введите корректную мощность"),
    [CAR_ENGINE_VOLUME]: minLengthValidation(3, "Введите корректный объем"),
    [CAR_COLOR]: minLengthValidation(3, "Введите корректный цвет"),
    [CAR_ENGINE_MODEL]: minLengthValidation(2, "Введите корректную модель"),
    [CAR_ENGINE_NUMBER]: NUMBERS_CARS_VALIDATION,
    [CAR_FRAME_NUMBER]: NUMBERS_CARS_VALIDATION,
    [CAR_BODY_NUMBER]: NUMBERS_CARS_VALIDATION,
    [PTC_SERIES]: {
        pattern: {
            value: /^\d{2}[А-Яа-яA-Za-z]{2}$/,
            message: "Серия ПТС должна содержать 2 цифры и 2 буквы."
        }
    },
    [PTS_NUMBER]: {
        pattern: {
            value: /^\d{6}$/,
            message: "Номер ПТС должен содержать 6 цифр."
        }
    },
    [PTC_DATE]: DATE_VALIDATION,
    [PTC_ISSUER]: minLengthValidation(3, "Введите корректное значение"),
    [CAR_NUMBER]: {
        pattern: {
            value: /^[АВЕКМНОРСТУХABEKMHOCTYX]\d{3}[АВЕКМНОРСТУХABEKMHOCTYX]{2}\d{2,3}$/,
            message:
                "Гос. номер должен быть в формате X000XX00*, используя разрешенные буквы и цифры."
        }
    },
    [STS_SERIES]: {
        pattern: {
            value: /^[A-Za-zА-Яа-я0-9]{4}$/,
            message: "Серия СТС должна содержать 4 символа, состоящих из букв и/или цифр."
        }
    },
    [STS_NUMBER]: {
        pattern: {
            value: /^\d{6}$/,
            message: "Номер СТС должен содержать 6 цифр."
        }
    },
    [STS_DATE]: DATE_VALIDATION,
    [STS_ISSUER]: minLengthValidation(3, "Введите корректное значение"),
    [CAR_PRICE]: minLengthValidation(4, "Введите корректную стоимость"),
    [CAR_ENGINE_OIL]: minLengthValidation(3, "Введите корректное значение"),
    [DAMAGE_DESCRIPTION]: minLengthValidation(10, "Введите корректное значение"),
    [ACCEPTANCE_CERT_DATE]: DATE_VALIDATION,
    [PASSPORT_SERIES]: {
        pattern: {
            value: /^\d{4}$/,
            message: "Серия паспорта должна содержать ровно 4 цифры."
        }
    },
    [CUSTOMER_PASSPORT_SERIES]: {
        pattern: {
            value: /^\d{4}$/,
            message: "Серия паспорта должна содержать ровно 4 цифры."
        }
    }
};

export enum MAX_LENGTH_INPUTS {
    PASSPORT_SERIES = 4,
    PASSPORT_NUMBER = 6,
    PASSPORT_CODE = 7,
    CAR_VIN = 17,
    CAR_YEAR = 4,
    PTC_SERIES = 4,
    PTS_NUMBER = 6,
    STS_SERIES = 4,
    STS_NUMBER = 6
}